module.exports = __webpack_public_path__ + "img/abi-gray.9008bde7.png";